module.exports = __webpack_public_path__ + "images/parkflyrent_small74cbc1894c513e44719a3b044ece51ca.png";